import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ProductionTechnologiesRecipes } from 'src/app/services/service/DataProviders/ProductionTechnologiesRecipes';
import * as _ from "lodash";
import { ArrayHelperService } from 'src/app/services/common/array-helper.service';
import { LogisticsInventoryStores } from 'src/app/services/service/DataProviders/LogisticsInventoryStores';
import { EditRecipes } from 'src/app/main-functions/edit-recipes';
import { SettingsService } from 'src/app/services/settings.service';
import { GeneralProductsProducts } from 'src/app/services/service/DataProviders/GeneralProductsProducts';
import { ProductionTechnologiesRecipeIngredients } from 'src/app/services/service/DataProviders/ProductionTechnologiesRecipeIngredients';

@Component({
  selector: 'editrecipes',
  templateUrl: './editrecipes.component.html',
  styleUrls: ['./editrecipes.component.scss']
})
export class EditrecipesComponent {


  //not used
  public tehnologieChoose;
  public replaceActive;
  public resultActive;
  public settingsActive;
  public infrastructureActive;
  //end not used

  public filteredRecepies: any[] = [];
  public filteredSelected: any[] = [];

  public recepiesToProcess: any[] = [];
  public recepiesToProcessSelected: any[] = [];

  public formInitialValues = {
    take: 10
  };
  public filterForm: FormGroup;

  public storeOptions = [];
  public disableProcessButton: Boolean = false;
  //result
  public executionLog;

  //settings
  public settingsForm: FormGroup = new FormGroup({
    new: new FormControl('false', [
      Validators.required
    ]),
    Store: new FormControl('', [
      Validators.minLength(4),
    ]),
    ReleaseDate: new FormControl(),
    ExpiryDate: new FormControl(),
    SaveStandartCost: new FormControl(false)
  });

  //substitude
  public substitude;
  public substitudesArray: Array<any> = [];
  saveSubstitude(subsObj) {

    let { subs, idx } = subsObj;

    if (!_.isNull(idx) && idx != undefined) {
      this.substitudesArray[idx] = _.clone(subs);
      this.settingsService.setSubstitudes(this.substitudesArray);
      return true;
    }


    if (!subs.autoAdded) {
      this.substitudesArray.push(_.clone(subs));
    }
    else {

      let res = _.find(this.substitudesArray, function (s) {
        let sameProducts = _.get(s, 'source.productName') == subs.source.productName
          && _.get(s, 'replace.productName') == subs.replace.productName
          && _.get(s, 'replace.storeName') == subs.replace.storeName

        //количество ако е null не позволява да се добавя 
        //TODO да се имплементират и проверки за количество
        return _.isEqual(s, subs)
      });

      if (!res) {
        this.substitudesArray.push(_.clone(subs));
      }

    }

    this.settingsService.setSubstitudes(this.substitudesArray);
  }

  // searchStores() {
  //   console.log(this.filterForm.value);
  //   let storeName = this.filterForm.value.Store;

  //   if(storeName == null) {
  //     return;
  //   }

  //   let call = JSON.parse(JSON.stringify(this.storeService.stateTemplate));
  //   call.filter.filters.push({ field: 'Name', operator: 'contains', value: storeName });

  //   this.storeService.filterStores(call)
  //   .subscribe((res: any) => {
  //     console.log(res.value);
  //     this.storeOptions = res.value;
  //   });
  // }
  public products: any;
  public loadingProducts: boolean = false;

  constructor(
    private recepieService: ProductionTechnologiesRecipes,
    private recipesIngService: ProductionTechnologiesRecipeIngredients,
    private storeService: LogisticsInventoryStores,
    private editRecipeService: EditRecipes,
    private settingsService: SettingsService,
    private productService: GeneralProductsProducts,
    private settingService: SettingsService,
  ) {
    this.createFilterForm();
    this.substitudesArray = this.settingsService.getSubstitudes();
  }

  public async startProcessing() {
    this.disableProcessButton = true;
    await this.editRecipeService.processList(this.recepiesToProcess, this.settingsForm, this.substitudesArray, this.storeOptions);
    this.disableProcessButton = false;
  }

  async fetchProducts(e = '') {
    this.loadingProducts = true;
    if(_.isNull(e) || _.isEmpty(e) || typeof e === "undefined") {
    this.loadingProducts = false;
      return this.products;
    }

    if(e.length < 3) {
      this.loadingProducts = false;
      return this.products;
    }

    this.products = await this.productService.filterByNameOrCode(e);
    this.loadingProducts = false;
    return this.products;
  }

  ngOnInit(): void {
    this.loadRecepies();
    this.loadStores();
    this.executionLog = this.editRecipeService.subscribeForLog();
  }

  loadStores() {
    let call = JSON.parse(JSON.stringify(this.storeService.stateTemplate));
    call.take = 1000;
    this.storeService.filterStores(call)
      .subscribe((res: any) => {
        this.storeOptions = res.value;
      });
  }


  async loadRecepies() {
    let filter = await this.buildFilter();
    let serv = this.recepieService;
    if (!_.isEmpty(this.filterForm.value.material)) {
      serv = this.recipesIngService;
    }

    serv.filterRecipeies(filter)
      .subscribe(
        (res: any) => {
          let recipies = res.value

          if (!_.isEmpty(this.filterForm.value.material)) {
            recipies = _.map(recipies, r => r.Recipe);
          }

          recipies.forEach((v, idx) => {
            recipies[idx].Ingredients = _.sortBy(recipies[idx].Ingredients, 'LineOrd');
          })

          this.filteredRecepies = recipies;
        },
        error => console.error(error)
      );
  }

  private createFilterForm() {
    this.filterForm = new FormGroup({
      Name: new FormControl('', [
        // Validators.required
      ]),
      take: new FormControl(this.formInitialValues.take, [
        Validators.required,
        Validators.min(1),
        Validators.pattern(/^[0-9]\d*$/),
      ]),
      Store: new FormControl('', [
        Validators.minLength(4),
      ]),
      ReleaseDate: new FormControl(),
      ExpiryDate: new FormControl(),
      material: new FormControl(),
    });
  }

  async buildFilter() {
    let call = JSON.parse(JSON.stringify(this.recepieService.stateTemplate));

    let nameFilter = {
      Name: 'contains',
      ReleaseDate: 'greaterequalnull',
      ExpiryDate: 'lessequalnull',
    }

    //ако има избран материал търсим в съставки а директно в технологии
    let prefix = '';
    if (!_.isEmpty(this.filterForm.value.material)) {
      prefix = 'Recipe/';
    }

    for (const property in nameFilter) {
      let value = this.filterForm.value[property];

      if (!_.isEmpty(this.filterForm.value[property])) {

        if (property == 'ReleaseDate' || property == 'ExpiryDate') {
          //преработвам датата в формат
          let date = value.split('.');
          value = date[2] + '-' + date[1] + '-' + date[0] + 'T00:00:00.000Z';
        }

        call.filter.filters.push({ field: prefix + property, operator: nameFilter[property], value: value });
      }
    }

    //филтър склад
    if (!_.isEmpty(this.filterForm.value.Store)) {
      let self = this;
      let store = _.find(this.storeOptions, function (o) {
        return _.get(o, 'Name.BG') === self.filterForm.value.Store
      });
      call.filter.filters.push({ field: prefix + 'Store', operator: 'eq', value: "'Logistics_Inventory_Stores(" + store.Id + ")'" });
    }

    //филтър материал
    if (!_.isEmpty(this.filterForm.value.material)) {
      for(let i = 0; i < this.filterForm.value.material.length; i++) {
        const material = this.filterForm.value.material[i];
        call.filter.filters.push({ field: 'Material', operator: 'eq', value: "'" + material['@odata.id'] + "'" });
      }
    }

    call.take = this.filterForm.value.take

    return call;
  }

  resetForm() {
    this.filterForm.reset();
    this.createFilterForm();
  }

  addRecipes() {
    this.recepiesToProcess = ArrayHelperService.unique([...this.recepiesToProcess, ...this.filteredSelected], "Id");
    this.filteredRecepies = ArrayHelperService.remove(this.filteredRecepies, this.recepiesToProcess, 'Id');
    this.filteredSelected = [];
  }

  removeFiltered() {
    this.filteredRecepies = ArrayHelperService.remove(this.filteredRecepies, this.filteredSelected, "Id");
    this.filteredSelected = [];
  }

  removeRecepiesToProcess() {
    this.filteredRecepies = ArrayHelperService.unique([...this.filteredRecepies, ...this.recepiesToProcessSelected], "Id");
    this.recepiesToProcess = ArrayHelperService.remove(this.recepiesToProcess, this.recepiesToProcessSelected, "Id");
    this.recepiesToProcessSelected = [];
  }

}
